import { action, makeAutoObservable, observable } from 'mobx';
import { RootStore } from './app.store';
import { History } from 'history';
import Cookies from 'js-cookie';

class GeneralStore {
  public rootStore: RootStore;

  public constructor(rootStore: RootStore) {
    makeAutoObservable(this, { rootStore: false });
    this.rootStore = rootStore;
  }

  public history: any | null = null;

  public loaderCounter: any = observable.object({ count: 0 });

  public showLoader = () => {
    this.loaderCounter = {
      count: this.loaderCounter.count + 1
    };
  };

  public hideLoader = () => {
    this.loaderCounter = {
      count: this.loaderCounter.count - 1
    };
  };

  @action.bound
  public setHistory = (history: any) => {
    this.history = history;
  };
}

export { GeneralStore };
